"use client"

import { useState } from "react";
import Sidebar from "./Sidebar";
import UserNavbar from "./UserNavbar";

export default function DashboardLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleToggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleCloseSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <>
      <style>{`
        .dashboard-container {
          display: flex;
          min-height: 100vh;
          background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
        }

        .sidebar-wrapper {
          position: relative;
          z-index: 1050;
        }

        .sidebar-overlay {
          display: none;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 1040;
          animation: fadeIn 0.3s ease;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        .sidebar-overlay.active {
          display: block;
        }

        .main-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          min-height: 100vh;
          margin-left: 240px;
          transition: margin-left 0.3s ease;
        }

        .navbar-sticky {
          // position: sticky;
          top: 0;
          z-index: 1020;
        }

        .page-content {
          flex: 1;
          overflow-y: auto;
        }

        /* Tablet screens (1024px and below) */
        @media (max-width: 1024px) {
          // .main-content {
          //   margin-left: 0;
          // }

          .sidebar-wrapper {
            position: fixed;
            left: 0;
            top: 0;
            // height: 100vh;
            z-index: 1050;
            transform: translateX(-100%);
            transition: transform 0.3s ease;
          }

          .sidebar-wrapper.active {
            transform: translateX(0);
          }

          .sidebar-overlay.active {
            display: block;
          }
        }

        /* Mobile screens (768px and below) */
        @media (max-width: 768px) {

          .main-content {
            margin-left: 0;
          }
          .page-content {
            padding: 1rem;
          }

          .navbar-sticky{
            position: sticky;
          }

          .sidebar-wrapper {
            width: 240px;
            box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
          }
        }

        /* Small mobile screens (480px and below) */
        @media (max-width: 480px) {

          .main-content {
            margin-left: 0;
          }
          .page-content {
            padding: 0.75rem;
          }

          .sidebar-wrapper {
            width: 100%;
            max-width: 280px;
          }
        }

        /* Scrollbar styling */
        .page-content::-webkit-scrollbar {
          width: 8px;
        }

        .page-content::-webkit-scrollbar-track {
          background: transparent;
        }

        .page-content::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 4px;
        }

        .page-content::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }
      `}</style>

      <div className="dashboard-container">
        {/* Sidebar Overlay for Mobile */}
        <div 
          className={`sidebar-overlay ${sidebarOpen ? "active" : ""}`}
          onClick={handleCloseSidebar}
        />

        {/* Sidebar */}
        <div className={`sidebar-wrapper ${sidebarOpen ? "active" : ""}`}>
          <Sidebar isOpen={sidebarOpen} onClose={handleCloseSidebar} />
        </div>

        {/* Main Content */}
        <main className="main-content">
          <div className="navbar-sticky">
            <UserNavbar onToggleSidebar={handleToggleSidebar} />
          </div>
          <div className="page-content">
            {children}
          </div>
        </main>
      </div>
    </>
  );
}
